import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'winter-radar-overlay-legend-svg',
  templateUrl: './winter_radar_overlay_legend.svg',
  styleUrl: '../../../../twc-legend/shared-legend-svg.css',
  standalone: true,
  imports: [CommonModule]
})
export class WinterRadarOverlaySvgComponent {}
